import React from 'react';
import { useNavigate } from 'react-router-dom';
import GenericEntityList from '../../components/Common/GenericEntityList';

const ProxyManagement: React.FC = () => {
  const navigate = useNavigate();

  const handleCreateProxy = () => {
    navigate('/proxies/create');
  };

  return (
    <GenericEntityList
      entityType="proxy"
      detailsRoute="/proxies"
      onCreateClick={handleCreateProxy}
      createButtonLabel="Add Proxy"
      showCreateButton={true}
      showExportButton={true}
    />
  );
};

export default ProxyManagement;

